import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de médico). */
export type CertidaoAlteracaoContratualPjJob = ReportJob;
export type CertidaoAlteracaoContratualPjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da Certidão de Alteração Contratual PJ. */
@Injectable({ providedIn: 'root' })
export class CertidaoAlteracaoContratualPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'certidao-alteracao-contratual-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.certidaoAlteracaoContratualPj;
}
